import React from "react";
import { motion } from "framer-motion";
import { projekte } from "../../helper/data";

const BilderVonHeimat = () => {
  const bilderVonHeimatProject = projekte.find(
    (project) => project.titel === "Bilder aus der neuen Heimat"
  );

  if (!bilderVonHeimatProject) {
    return <p>Projekt nicht gefunden.</p>;
  }

  return (
    <div className="container my-4 text-center">
      <motion.div
        className="bg-light p-4 p-md-5 rounded shadow text-start responsive-fs"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src={bilderVonHeimatProject.images[0]}
          alt="Demokratie"
          className="img-fluid rounded mb-3 w-100"
          style={{ maxHeight: "800px" }}
        />
        <h3 className="fw-semibold text-success mt-4 mb-3">
          {bilderVonHeimatProject.titel.toUpperCase()}
        </h3>
        <div>
          <p className="justify-text mb-3">{bilderVonHeimatProject.desc2}</p>
        </div>
        <div>
          <strong>Projektzeitraum:</strong> 01.10.2025 – 31.10.2025
        </div>
        <div>
          <strong>Anzahl der geförderten Kinder:</strong> 15
        </div>
        <div>
          <strong>Förderer:</strong> Deutsches Kinderhilfswerk
        </div>

        <div>
          <h3 className="mt-3">{bilderVonHeimatProject.titel2}</h3>
          <p className="justify-text">{bilderVonHeimatProject.desc3}</p>
        </div>

        <div>
          <h3 className="mt-3">{bilderVonHeimatProject.titel3}</h3>
          <p className="justify-text">{bilderVonHeimatProject.desc4}</p>
        </div>

        <div>
          <p className="card-text mt-4">
            Melde dich an und werde Teil dieses wichtigen Projekts unter:{" "}
            <a href="mailto:info@harmonieneuss.de">info@harmonieneuss.de</a>
          </p>
        </div>
        <img
          src={bilderVonHeimatProject.images[1]}
          alt="Demokratie"
          className="img-fluid rounded mb-3"
        />
      </motion.div>
    </div>
  );
};

export default BilderVonHeimat;
